import { createSelector } from "reselect"
import { get } from "lodash"
import { getSelectedDate } from "selectors/dates"
import { getIsOpPro } from "modules/account-root/selectors"
import { getTagCategories, getAttributeCategories } from "modules/portfolio-root/selectors"
import { getFilter, getEffectiveNormalization } from "./filters"
import { getAllAvailableRollups } from "helpers/rollups"
import { computeFilteredSegment } from "helpers/segments"
import { VIEW_TYPES } from "helpers/base"

export const getRawSort = state => get(state, "modules.analyzeFactors.sort")
export const getAccount = state => get(state, "global.selected.account")
const getSelectedPortfolio = (state) => get(state, "global.selected.portfolio")
export const getAccountId = state => get(state, "global.selected.accountId")
export const getPortfolioId = state => get(state, "global.data.portfolio.data.id")
const getClassifications = state => get(state, "global.data.classifications.data.classifications")
export const getSelectedScreen = (_, props) => get(props, "params.selectedScreen")

const getAccountRollups = createSelector(
  [getClassifications, getTagCategories, getAttributeCategories],
  (classifications, tagCategories, attributeCategories) => ({
    classifications,
    tagCategories,
    attributeCategories,
  }),
)

export const getAvailableRollups = createSelector(
  [getAccountRollups, getSelectedDate],
  (accountRollups, date) => getAllAvailableRollups(accountRollups, date, VIEW_TYPES.ABSOLUTE),
)

export const getSegment = createSelector(
  [getFilter, getEffectiveNormalization],
  computeFilteredSegment,
)

export const getMenuItems = createSelector(
  [getIsOpPro],
  (isOpPro) => [
    {
      id: "performance",
      label: "Performance",
      order: 0,
      groupId: "factors",
      groupLabel: "Factors Review",
    },
    {
      id: "risk",
      label: "Risk",
      order: 1,
      groupId: "factors",
      groupLabel: "Factors Review",
      disabled: isOpPro,
      tooltip: isOpPro ? "Only available with enterprise plan" : null,
    },
  ],
)

export const getPositionSet = createSelector(
  [getSelectedPortfolio],
  (portfolio) => ({
    id: portfolio,
    type: "PORTFOLIO",
  }),
)
